<template>
  <x-page :title="isAdd ? '新增地址' : '编辑地址'" :loading="loading">
    <div :class="_.page">
      <div :class="_.form">
        <div :class="_.bd">
          <label :class="[_.field, _._hairlineBottom]">
            <div :class="_.label">姓名</div>
            <input
              v-model="addressData.receiver"
              :class="_.value"
              placeholder="请填写姓名"
            />
          </label>
          <label :class="[_.field, _._hairlineBottom]">
            <div :class="_.label">手机号</div>
            <input
              v-model="addressData.phoneNo"
              :class="_.value"
              placeholder="请填写手机号"
            />
          </label>
          <label
            :class="[_.field, _._hairlineBottom]"
            @click="addressPickerVisible = true"
          >
            <div :class="_.label">所在区域</div>
            <input
              :class="_.value"
              placeholder="请选择所在区域"
              :value="
                `${addressData.province} ${addressData.city} ${
                  addressData.county
                } ${addressData.street || ''}`.trim()
              "
              :readonly="true"
            />
            <img src="./images/箭头.png" :class="_.arrow" />
          </label>
          <!-- <label :class="[_.field, _._hairlineBottom]">
            <div :class="_.label">街道信息</div>
            <input
              v-model="addressData.street"
              class="van-ellipsis"
              :class="_.value"
              placeholder="请填写街道信息"
            />
            <img
              src="./images/定位.png"
              alt=""
              :class="_.coord"
              @click="goCoord"
            />
          </label> -->

          <label :class="_.field">
            <div :class="_.label">详细地址</div>
            <textarea
              v-model="addressData.detail"
              :rows="3"
              :class="_.value"
              placeholder="详细地址：如道路、门牌号、小区、楼栋号、单元室等"
            />
          </label>
        </div>
        <div :class="_.ft">
          <label :class="_.field">
            <div :class="_.label">是否设为默认地址</div>
            <van-switch
              v-model="addressData.defaultFlag"
              :class="_.value"
              :active-value="1"
              :inactive-value="0"
              inactive-color="#CCCCCC"
              active-color="#18B2B9"
            />
          </label>
        </div>
      </div>

      <div :class="_.actions">
        <div :class="_.button" @click="handleSaveClick">保存地址</div>
      </div>

      <van-popup v-model="addressPickerVisible" round position="bottom">
        <!-- <van-picker
          :show-toolbar="true"
          :columns="divisionData"
          @cancel="addressPickerVisible = false"
          @confirm="handleAddressPickerConfirm"
        /> -->
        <van-cascader
          v-model="cascaderValue"
          title="请选择所在地区"
          :options="divisionData"
          :field-names="{
            text: 'districtName',
            value: 'districtId',
          }"
          @close="addressPickerVisible = false"
          @finish="handleAddressPickerConfirm"
          @change="loadData"
        />
      </van-popup>
    </div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { yup as _ } from 'vtils/validator'
  import {
    apiBasicAddressList,
    apiBasicAddressSave,
    apiMerchantDistrictDistrictLevelList,
  } from '@/api'
  import { mapQuery, prepareData, submit } from '@/utils'
  import { navigateBack } from '@/router'

  export default Vue.extend({
    noKeepalive: true,

    mixins: [
      mapQuery({
        id: 'id',
      }),
    ],

    data: () => ({
      loading: true,
      addressPickerVisible: false,
      addressData: {},
      divisionData: [],
      cascaderValue: '',
    }),

    computed: {
      isAdd() {
        return !this.id
      },
    },

    async mounted() {
      // this.$eventBus.on('setStreet', payload => {
      //   this.addressData.street = payload
      // })

      const { addressData, divisionData } = await prepareData({
        addressData: !this.id
          ? {
              receiver: '',
              phoneNo: '',
              province: '',
              provinceCode: '',
              city: '',
              cityCode: '',
              county: '',
              districtCode: '',
              street: '',
              streetCode: '',
              defaultFlag: 0,
              detail: '',
            }
          : apiBasicAddressList({}).then(res =>
              res.list.find(item => item.id === this.id),
            ),
        divisionData: apiMerchantDistrictDistrictLevelList({}).then(res => {
          const arr = res.map(item => {
            item.children = []
            return item
          })
          return arr
        }),
      })
      this.addressData = addressData
      this.divisionData = divisionData
      this.loading = false
    },

    methods: {
      // async goCoord() {

      //   this.$router.push({
      //     path: '/address/coord',
      //     query: {
      //       city: [
      //         this.addressData.province,
      //         this.addressData.city,
      //         this.addressData.county,
      //       ]
      //         .filter(Boolean)
      //         .join(''),
      //     },
      //   })
      // },
      async loadData({ value, selectedOptions }) {
        const item = selectedOptions[selectedOptions.length - 1]
        if (
          item.currentLevel < 4 &&
          item.hasChildren &&
          (!item.children || !item.children.length)
        ) {
          const data = await apiMerchantDistrictDistrictLevelList({
            parentId: value,
          })
          this.$set(item, 'children', data)
        }
      },
      handleSaveClick() {
        submit(async $ => {
          const rules = _.object({
            receiver: _.string().required('请输入姓名'),
            phoneNo: _.string().required('请输入手机号'),
            province: _.string().required('请选择所在区域'),
            city: _.string().required('请选择所在区域'),
            county: _.string(),
            // street: _.string().required('请选择街道信息'),
            detail: _.string().required('请输入详细地址'),
            defaultFlag: _.number(),
          })
          const { data, error } = rules.validatePlusSync(this.addressData)
          if (error) {
            return $.fail(error.message)
          }
          await $.start('保存中...')
          await apiBasicAddressSave({
            ...data,
            // 适配港澳台等两级地址
            districtCode: data.districtCode || data.cityCode,
          })
          await $.success('保存成功')
          navigateBack()
        })
      },
      handleAddressPickerConfirm({ selectedOptions }) {
        const item = selectedOptions[selectedOptions.length - 1]
        if (!item.hasChildren || item.currentLevel === 4) {
          this.addressData.province = selectedOptions[0].districtName
          this.addressData.provinceCode = selectedOptions[0].districtId
          this.addressData.city = selectedOptions[1].districtName
          this.addressData.cityCode = selectedOptions[1].districtId
          this.addressData.county = selectedOptions[2].districtName
          this.addressData.districtCode = selectedOptions[2].districtId
          if (item.currentLevel === 4) {
            this.addressData.street = selectedOptions[3].districtName
            this.addressData.streetCode = selectedOptions[3].districtId
          }
          if (item.currentLevel === 3) {
            this.addressData.street = ''
            this.addressData.streetCode = ''
          }

          this.addressPickerVisible = false
        }
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .form {
      flex-grow: 1;
      overflow: auto;

      .bd {
        background-color: white;
        padding-left: 12px;

        .field {
          display: flex;
          align-items: baseline;
          padding: 16px 12px 16px 0;

          .label {
            flex-shrink: 0;
            font-size: 16px;
            color: #333333;
            width: 84px;
          }

          .value {
            flex-grow: 1;
            appearance: none;
            outline: none;
            border: none;
            border-radius: 0;
            box-shadow: none;
            font-size: 16px;
            color: #333333;

            &::placeholder {
              color: #cccccc;
            }
          }

          .arrow {
            flex-shrink: 0;
            width: 14px;
            height: 15px;
            user-select: none;
            -webkit-touch-callout: none;
          }
          .coord {
            margin-left: 5px;
            flex-shrink: 0;
            width: 20px;
            user-select: none;
            -webkit-touch-callout: none;
          }
        }
      }

      .ft {
        margin-top: 8px;
        background-color: white;
        padding-left: 12px;

        .field {
          display: flex;
          align-items: center;
          padding: 12px 12px 12px 0;

          .label {
            flex-grow: 1;
            font-size: 16px;
            color: #333333;
          }

          .value {
            flex-shrink: 0;
          }
        }
      }
    }

    .actions {
      flex-shrink: 0;
      padding: 12px;
      user-select: none;

      .button {
        height: 50px;
        background: #ff960a;
        border-radius: 1000px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;

        .icon {
          width: 14px;
          height: 14px;
          user-select: none;
          -webkit-touch-callout: none;
          margin-right: 4px;
        }

        &:active {
          filter: contrast(0.9);
        }
      }
    }
  }
</style>
